export default "__VITE_ASSET__DRMel8pP__"